import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/utils/redux/store';
import { StorageEnum } from '~/utils/enum/base';
import { createCanvasToken, handleLogin, handleLoginWithUrl } from './authThunk';
import { IUserProfile } from '~/utils/interface/account';

export interface AuthState {
  accessToken?: string;
  user?: IUserProfile;
  loginUrl?: string;
}

const initialState: AuthState = {
  loginUrl: undefined,
  accessToken: localStorage.getItem(StorageEnum.ACCESS_TOKEN) || undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleLogout() {
      localStorage.removeItem(StorageEnum.ACCESS_TOKEN);
    },
    setAccessToken(state, action) {
      state.accessToken = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleLogin.pending, (state) => {})
      .addCase(handleLogin.fulfilled, (state, action) => {})
      .addCase(handleLogin.rejected, (state) => {});

    // loginUrl
    builder
      .addCase(handleLoginWithUrl.pending, (state) => {})
      .addCase(handleLoginWithUrl.fulfilled, (state, action) => {
        state.loginUrl = action.payload;
      })
      .addCase(handleLoginWithUrl.rejected, (state) => {});

    // Create Canvas Token
    builder
      .addCase(createCanvasToken.pending, (state) => {})
      .addCase(createCanvasToken.fulfilled, (state, action) => {
        state.accessToken = action.payload.data.token.access;
      })
      .addCase(createCanvasToken.rejected, (state, action) => {});
  },
});

export const authActions = authSlice.actions;

export const selectAccessToken = (state: RootState) => state.auth.accessToken;
export const selectLoginUrl = (state: RootState) => state.auth.loginUrl;

const authReducer = authSlice.reducer;
export default authReducer;
